
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/enable-v2",
      function () {
        return require("private-next-pages/auth/enable-v2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/enable-v2"])
      });
    }
  